import { FaLock } from "react-icons/fa";
import CreateView from "../Component/CreateView";
import DeleteView from "../Component/DeleteView";
import FileView from "../Component/FIleView";
import { useState, useEffect, useRef } from "react";
import { getFileIcon } from "../utils/Icon";
import { getAllFolder, updateFolder } from "../api/folderapi";
import { useNavigate } from "react-router-dom";
import { HiDotsVertical } from "react-icons/hi";
import useFiles, { FileContext } from "../context/FileContext";
import { deleteFolder } from "../api/folderapi";
import { toast } from "react-hot-toast";
import FileContainer from "../Component/FileContainer";
import Loader from "../Component/Loader";
import { value } from "../data/item";
import ShareView from "../Component/ShareView";
import MoveModal from "../Component/MoveModel";
import FileInformation from "../Component/FileInformation";
import { FaList, FaRegStar } from "react-icons/fa";
import { sampleData } from "../data/mappingdata";
import { Tuning2 } from "@solar-icons/react";
import { IoGridOutline } from "react-icons/io5";
import { IoIosArrowUp } from "react-icons/io";
import { formatBytes } from "../utils/sizeCalculater";
import MenuComponent from "../Component/MenuComponent";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegShareFromSquare } from "react-icons/fa6";
import { ClipboardCheck } from "@solar-icons/react";
import { IoLockOpenOutline } from "react-icons/io5";
/* import FilePreview from "../Component/FileThumbPreview"; */


const Home = () => {
  const { files, setFiles, viewType, setViewType, search } = useFiles();
  const naviagate = useNavigate();
  const [datas, setDatas] = useState([]);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [fileInput, setFileInput] = useState(null);
  const [fileType, setFileType] = useState("Folder");
  const [currentFolder, setCurrentFolder] = useState(null);
  const [selectedFolderForDelete, setSelectedFolderForDelete] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [menuOpenId, setMenuOpenId] = useState(false);
  const [selectedForMove, setSelectedForMove] = useState(null);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [infoFile, setInfoFile] = useState(null);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [items, setItems] = useState([]);
  const [renamingId, setRenamingId] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [infoModel, setInfoModel] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [checkboxOpen, setCheckboxOpen] = useState(false);
  const [showAllFolder,setShowAllFolder] = useState(false);
  const [showAllFile,setShowAllFile] = useState(false);
  const navigate = useNavigate();

const handleDownload = (file) => {
  if (!file) {
    alert("Missing file!");
    return;
  }

  // Get the URL
  const fileUrl = file.url; // for files
  if (!fileUrl) {
    alert("Download URL is missing!");
    return;
  }

  // Create a temporary link
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = file.name || fileUrl.split("/").pop();
  link.target = "_blank"; // optional
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
 

  const fetchFolders = async () => {
    try {
      setIsLoading(true);
      const res = await getAllFolder();
      setDatas(res.data);
      const rootFolders = res.data.filter((d) => d.type === "folder");
      setFiles(rootFolders);
    } catch (error) {
      console.error("Error fetching folders:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteConfirm = async (_id, name) => {
    try {
      if (selectedFolderForDelete) {
        const res = await deleteFolder(selectedFolderForDelete._id);

        toast.success(res.message);
        fetchFolders();
        setIsPopupOpen(false);
        setSelectedFolderForDelete(null);
        setMenuOpen(null);
      }
    } catch (error) {
      toast.error("Error deleting folder");
    }
  };

  const handleDeleteCancel = () => {
    setIsPopupOpen(false);
    setSelectedFolderForDelete(null);
  };

  const handleFolderClick = (folder) => {
    if (folder.isLocked) {
      const enteredPassword = prompt(
        "This folder is locked. Enter the password:"
      );
      if (enteredPassword !== folder.password) {
        alert("Incorrect password! Access denied.");
        return;
      }
    }

    if (folder.isDirectory) {
      setBreadcrumb((prev) => [...prev, folder]);
      setCurrentFolder(folder);
    } else {
      console.log("File clicked (no drill‐down):", folder.name);
    }
  };

  const handleItemClick = (item) => {
    /*   console.log('clicked',item); */
    if (item.type === "folder") {
      naviagate("/folder/" + item._id);
    } else {
      setSelectedFile(item);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(null);
        setDropDown(null);
        setMenuOpenId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchFolders();
  }, [isCreateModalOpen]);

  const handleCreate = (con) => {
    console.log(con);
    setIsCreateModalOpen(con);
  };

  useEffect(() => {
    getAllFolder()
      .then((res) => {
        const files = res.data
          .filter(
            (item) =>
              item.mimeType &&
              item.mimeType.toLowerCase().includes("application") &&
              item.size
          )
          .map((item) => ({
            ...item,
            sizeMB: (Number(item.size) / (1024 * 1024)).toFixed(2),
          }));

        setItems(files);
      })
      .catch((err) => console.log(err));
  }, []);

  const toggleSelection = (fileId) => {
    setSelectedItems((prev) =>
      prev.includes(fileId)
        ? prev.filter((id) => id !== fileId)
        : [...prev, fileId]
    );
  };


  const displayedFiles = files.filter((file) =>
  file.name?.toLowerCase().includes(search.toLowerCase())
);

const filteredDatas = datas.filter((item) =>
  item.name?.toLowerCase().includes(search.toLowerCase())
);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="">
      <div>
        <span className="   text-xl lg:text-2xl font-semibold text-secondary    ">
          Welcome to Azero Drive
        </span>
        <div
          className={`grid gap-5 
    grid-cols-2 
    ${
      showShareModal || showInfoModal || showFilter
        ? "md:grid-cols-4 w-[80%]"
        : "sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 w-full mt-3"
    }`}
        >
          {sampleData.map((item, index) => (
            <div
              key={index}
              onClick={() => navigate(item.route)}
              className=" p-2 border border-gray-300 rounded-2xl"
            >
              <div className=" rounded-lg overflow-hidden">
                <img src={item.icon} alt={item.name} className=" w-full h-auto object-contain"/>
              </div>
              <div className=" flex justify-between items-center mt-2">
                <span className="text-xs font-semibold text-secondary">
                  {item.name}
                </span>
                <p className="text-[10px] font-medium text-icon">
                  {formatBytes(
                    datas
                      .filter(
                        (d) =>
                          d.type === "file" &&
                          d.mimeType &&
                          d.mimeType.includes(item.name.toLowerCase())
                      )
                      .reduce((acc, cur) => {
                        return (acc += cur.size);
                      }, 0)
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className=" flex justify-between mt-5">
        <h4 className="text-secondary font-semibold text-xl">
          Suggested Folder
        </h4>

        <div
          className={`flex justify-end gap-3 ${
            showShareModal || showInfoModal || showFilter
              ? " fex justify-end mr-[20%] "
              : ""
          }`}
        >
          <div>
            {selectedItems.length > 0 && (
              <div className="flex items-center gap-3 text-sm font-medium ">
                <span>{selectedItems.length} file(s) selected</span>
                <div className="w-10 h-10 border border-gray-300 rounded-md flex items-center justify-center hover:bg-gray-100 cursor-pointer">
                  <MdDeleteOutline fontSize={20} />
                </div>
                <div className="w-10 h-10 border border-gray-300 rounded-md flex items-center justify-center hover:bg-gray-100 cursor-pointer">
                  <FaRegShareFromSquare className="cursor-pointer text-lg" />
                </div>
              </div>
            )}
          </div>
          <div className="hidden md:w-10 h-10 border border-gray-300 rounded-md md:flex items-center justify-center hover:bg-gray-100 cursor-pointer">
            <ClipboardCheck onClick={() => setCheckboxOpen(!checkboxOpen)} />
          </div>
          <div className="hidden md:w-10 h-10 border border-gray-300 rounded-md md:flex items-center justify-center hover:bg-gray-100 cursor-pointer">
            <Tuning2 onClick={() => setShowFilter(!showFilter)} />
            {/*  {showFilter && <FilterContainer setShowFilter={setShowFilter} />} */}
          </div>

          <div className="flex border border-gray-300  rounded-md overflow-hidden w-fit h-10">
            <button
              className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                viewType === "list" ? "bg-four text-black" : "text-secondary "
              }`}
              onClick={() => {
                setViewType("list");
                setIsMenuOpen(false);
              }}
            >
              <FaList />
            </button>

            <button
              className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                viewType === "grid" ? "bg-four text-black" : "text-secondary "
              }`}
              onClick={() => {
                setViewType("grid");
                setIsMenuOpen(false);
              }}
            >
              <IoGridOutline />
            </button>
          </div>

          <button
            className=" hidden md:w-[150px] h-10 md:flex items-center justify-center gap-2 border border-gray-300 bg-four text-secondary font-medium text-sm rounded-md hover:opacity-90 transition"
            onClick={() => setShowAllFolder(!showAllFolder)}
          >
            <span>View all</span>
            <IoIosArrowUp
              fontSize={20}
              className={`transition-transform duration-300 ${
                showAllFolder ? "rotate-180" : ""
              }`}
            />
          </button>
        </div>
      </div>
      {viewType === "grid" ? (
        <div>
          <div className=" flex flex-col gap-3">
            <div
              className={`grid gap-5 
    grid-cols-2 
    ${
      showShareModal || showInfoModal || showFilter
        ? "md:grid-cols-4 w-[80%]"
        : "sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 w-full mt-5"
    }`}
            >
              {displayedFiles
                ?.filter((file) => !file.trashed)
                ?.filter(
                  (file) =>
                    search?.toLowerCase() === "" ||
                    file.name?.toLowerCase().includes(search.toLowerCase())
                )
                .slice(0, showAllFolder ? files.length : 5)
                .map((file) => {
                  const fileId = file._id || file.id;
                  const isSelected = selectedItems.includes(fileId);
 
                  const handleRenameConfirm = async () => {
                    if (renameValue.trim()) {
                      try {
                        const updated = await updateFolder(
                          file._id,
                          renameValue.trim()
                        );

                        setFiles((prev) =>
                          prev.map((f) =>
                            f._id === file._id
                              ? {
                                  ...f,
                                  name:
                                    updated.data?.name || renameValue.trim(),
                                }
                              : f
                          )
                        );
                      } catch (error) {
                        console.error("Failed to rename folder", error);
                      }
                    }
                    setRenamingId(null);
                  };

                  return (
                    <FileContainer
                      key={fileId}
                      className={` group cursor-pointer border px-2 py-1  transition-all duration-300  ${
                        isSelected
                          ? "ring-2 ring-blue-500 bg-blue-50"
                          : "hover:ring-1 hover:ring-gray-400"
                      }`}
                    >
                      {checkboxOpen && (
                        <div className=" top-2 right-3 z-10">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => toggleSelection(fileId)}
                            className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                          />
                        </div>
                      )}
                      <div className="w-10 h-12  ">
                        <img
                          className={`w-full h-full object-contain rounded-md ${
                            file.isLocked ? "blur-sm opacity-60" : ""
                          }`}
                          onClick={() => {
                            if (file.isLocked && file.privacy === "private") {
                              const entered = prompt("Enter password:");
                              if (entered === file.password)
                                handleItemClick(file);
                              else alert("Incorrect password");
                            } else {
                              handleItemClick(file);
                            }
                          }}
                          src={getFileIcon(file.name, file.url)}
                          alt={file.name}
                        />
                      </div>

                      {renamingId === file._id ? (
                        <input
                          autoFocus
                          value={renameValue}
                          onChange={(e) => setRenameValue(e.target.value)}
                          onBlur={() => setRenamingId(null)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleRenameConfirm();
                            else if (e.key === "Escape") setRenamingId(null);
                          }}
                          className="text-sm border outline-none  px-2 py-1 w-full rounded-md"
                        />
                      ) : (
                        <span
                          className=" font-medium text-sm truncate cursor-pointer"
                          onClick={() =>
                            !file.isLocked &&
                            (file.isDirectory
                              ? handleFolderClick(file)
                              : handleItemClick(file))
                          }
                        >
                          {file?.name?.slice(0, 20)}
                        </span>
                      )}

                      <div className="flex justify-between text-[11px] text-gray-600 w-full">
                        {(() => {
                          const filtered = datas.filter(
                            (f) => f.parentId === file._id
                          );
                          const totalSize = filtered.reduce(
                            (acc, cur) => acc + (cur.size || 0),
                            0
                          );
                          return (
                            <>
                              <span>{filtered.length} items</span>
                              <span>{formatBytes(totalSize)}</span>
                            </>
                          );
                        })()}
                      </div>
                      <div className="absolute flex justify-between top-2 right-2  space-x-2 text-black ">
                       {/*  <div>
                        <IoLockOpenOutline/>
                      </div> */}
                      {/*   <button>
                          <FaRegStar fontSize={20} className="text-icon" />
                        </button> */}
                        <button
                          onClick={() =>
                            setMenuOpenId(menuOpenId === fileId ? null : fileId)
                          }
                        >
                          <HiDotsVertical fontSize={20} className="text-icon" />
                        </button>
                      </div>

                      {menuOpenId === fileId && (
                        <MenuComponent
                          datas={files}
                          file={file}
                          setMenuOpenId={setMenuOpenId}
                          renameValue={renameValue}
                          setRenameValue={setRenameValue}
                          setRenamingId={setRenamingId}
                          showShareModal={showShareModal}
                          infoModel={infoModel}
                          setInfoModel={setInfoModel}
                          setShowShareModal={setShowShareModal}
                          showInfoModal={showInfoModal}
                          setShowInfoModal={setShowInfoModal}
                          setInfoFile={setInfoFile}
                        />
                      )}
                      {showShareModal && (
                        <ShareView
                          setIsOpen={setShowShareModal}
                          handleShare={() => {
                            toast.success("File shared successfully!");
                            setShowShareModal(false);
                          }}
                        />
                      )}

                      {showInfoModal && infoFile && (
                        <FileInformation
                          showInfoModal={showInfoModal}
                          infoFile={infoFile}
                          onClose={() => setShowInfoModal(false)}
                        />
                      )}

                      {showMoveModal && selectedForMove && (
                        <MoveModal
                          file={selectedForMove}
                          folders={files.filter(
                            (f) => f.isDirectory && !f.trashed
                          )}
                          onClose={() => setShowMoveModal(false)}
                          onMove={(destinationId) => {
                            setFiles((prev) =>
                              prev.map((f) =>
                                f._id === selectedForMove._id
                                  ? { ...f, parentId: destinationId }
                                  : f
                              )
                            );
                            setShowMoveModal(false);
                            toast.success("Moved successfully");
                          }}
                        />
                      )}
                    </FileContainer>
                  );
                })}
            </div>
          </div>

          <div className="flex justify-between mt-5">
            <h4 className="text-secondary font-semibold text-xl">
              Suggested Files
            </h4>
            <button
              className="w-[150px] h-10 flex items-center justify-center gap-2 border border-gray-300 bg-four text-secondary font-medium text-sm rounded-md hover:opacity-90 transition"
              onClick={() => setShowAllFile(!showAllFile)}
            >
              <span>View all</span>
              <IoIosArrowUp
                fontSize={20}
                className={`transition-transform duration-300 ${
                  showAllFile ? "rotate-180" : ""
                }`}
              />
            </button>
          </div>
       <div
            className={`grid gap-5 
    grid-cols-2 
    ${
      showShareModal || showInfoModal || showFilter
        ? "md:grid-cols-4 w-[80%]"
        : "sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 w-full mb-10 mt-5 "
    }`}
          >
            {filteredDatas
              .filter((item) => item.type === "file")
              .slice(0, showAllFile ? datas.length : 5)
              .map((file) => {
                const icon = getFileIcon(file.name, file.url);
                const fileId = file._id || file.id;

                 const handleRenameConfirm = async () => {
  if (!renameValue.trim()) return;
 try {
    const updated = await updateFolder(file._id, renameValue.trim());
    fetchFolders()

  } catch (error) {
    console.error("Failed to rename folder", error);
  } finally {
    setRenamingId(null);
  }
}; 

                return (
                  <div
                    key={fileId}
                    className="relative flex flex-col items-center bg-four p-1 border border-gray-300 rounded-2xl "
                  >
                   
                    <div className="absolute top-2 right-2 flex space-x-2 text-black ">
                      
                      {/* <button>
                        <FaRegStar fontSize={20} className="text-icon" />
                      </button> */}
                      <button
                        onClick={() =>
                          setMenuOpenId(menuOpenId === fileId ? null : fileId)
                        }
                      >
                     
                        <HiDotsVertical fontSize={20} className="text-icon" />
                      </button>

                      {menuOpenId === fileId && (
                        <MenuComponent
                          datas={files}
                          file={file}
                          setMenuOpenId={setMenuOpenId}
                          renameValue={renameValue}
                          setRenameValue={setRenameValue}
                          setRenamingId={setRenamingId}
                          showShareModal={showShareModal}
                          infoModel={infoModel}
                          setInfoModel={setInfoModel}
                          setShowShareModal={setShowShareModal}
                          showInfoModal={showInfoModal}
                          setShowInfoModal={setShowInfoModal}
                          setInfoFile={setInfoFile}
                        />
                      )}
                    </div>

                {/*     <div className="w-full h-24 rounded-lg overflow-hidden">
  <div
    onClick={() => {
      if (file.isLocked && file.privacy === "private") {
        const entered = prompt("Enter password:");
        if (entered === file.password) handleItemClick(file);
      } else {
        handleItemClick(file);
      }
    }}
    className={`w-full h-full ${
      file.isLocked ? "blur-sm opacity-60" : ""
    }`}
  >
    <FilePreview file={file} />
  </div>
</div>
 */}

 
   <div className=" w-full h-24 rounded-lg overflow-hidden">
                      <img
                        className={`w-full h-full object-cover rounded-md items-center  ${
                          file.isLocked ? "blur-sm opacity-60" : ""
                        }`}
                        onClick={() => {
                          if (file.isLocked && file.privacy === "private") {
                            const entered = prompt("Enter password:");
                            if (entered === file.password)
                              handleItemClick(file);
                          } else {
                            handleItemClick(file);
                          }
                        }}
                        src={getFileIcon(file.name, file.url)}
                        alt={file.name}
                      />
                    </div> 

                          {renamingId === file._id ? (
                        <input
                          autoFocus
                          value={renameValue}
                          onChange={(e) => setRenameValue(e.target.value)}
                          onBlur={() => setRenamingId(null)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleRenameConfirm();
                            else if (e.key === "Escape") setRenamingId(null);
                          }}
                          className="text-sm border outline-none  px-2 py-1 w-full rounded-md"
                        />
                      ) : (
                       <div className=' mt-2  flex justify-start'>
  <span
    className="font-medium text-xs truncate cursor-pointer  "
    onClick={() =>
      !file.isLocked &&
      (file.isDirectory
        ? handleFolderClick(file)
        : handleItemClick(file))
    }
  >
    {file.name.slice(0, 10)}
  </span>
</div>

                      )}  

                   {/*  <span className="text-sm text-center font-medium text-gray-700 truncate w-full p-2">
                      {file.name.slice(0, 10)}
                    </span> */}
                  </div>
                );
              })}
          </div>
        </div>
      ) : (
        <div>
          <div className="w-full overflow-x-auto mt-5">
            <table
              ref={menuRef}
              className="min-w-[700px] w-full table-auto  text-sm text-left"
            >
              <thead className=" text-xs md:text-sm">
                <tr className="text-secondary font-semibold">
                  {["Name", "Created At", "Main Access", "Size", "More"].map(
                    (col, i) => (
                      <th
                        key={i}
                        className="p-2 md:p-4 whitespace-nowrap text-secondary"
                      >
                        {col}
                      </th>
                    )
                  )}
                </tr>
              </thead>

              <tbody>
                {displayedFiles
                  .filter((file) => !file.trashed)
                  .filter((item) => item.type === "folder")
                  .slice(0, showAllFolder ? datas.length : 5)
                  .map((file, index) => {
                    const fileId = file.id || file._id;
                    const handleRenameConfirm = async () => {
                    if (renameValue.trim()) {
                      try {
                        const updated = await updateFolder(
                          file._id,
                          renameValue.trim()
                        );

                        setFiles((prev) =>
                          prev.map((f) =>
                            f._id === file._id
                              ? {
                                  ...f,
                                  name:
                                    updated.data?.name || renameValue.trim(),
                                }
                              : f
                          )
                        );
                      } catch (error) {
                        console.error("Failed to rename folder", error);
                      }
                    }
                    setRenamingId(null);
                  };

                    return (
                      <tr
                        key={fileId}
                        className="hover:bg-third transition-all duration-200"
                      >
                        {/* Name */}
                        <td className="p-2 md:p-4 text-secondary">
                          <div className="flex items-center gap-5 ">
                            <div className="relative w-8 h-8 md:w-10 md:h-10">
                              {file.isLocked && (
                                <FaLock
                                  className="absolute top-0 left-0 text-red-500 z-10"
                                  fontSize={14}
                                />
                              )}
                              <img
                                src={getFileIcon(file.name, file.url)}
                                alt={file.name}
                                onClick={() => handleItemClick(file)}
                                className={`w-full h-full rounded-md object-cover transition-all duration-300 ${
                                  file.isLocked && !file.isDirectory
                                    ? "blur-md opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                              />
                            </div>
                             {renamingId === file._id ? (
                        <input
                          autoFocus
                          value={renameValue}
                          onChange={(e) => setRenameValue(e.target.value)}
                          onBlur={() => setRenamingId(null)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleRenameConfirm();
                            else if (e.key === "Escape") setRenamingId(null);
                          }}
                          className="text-sm border outline-none  px-2 py-1 w-full rounded-md"
                        />
                      ) : (
                        <span
                          className=" font-medium text-sm truncate cursor-pointer"
                          onClick={() =>
                            !file.isLocked &&
                            (file.isDirectory
                              ? handleFolderClick(file)
                              : handleItemClick(file))
                          }
                        >
                          {file.name.slice(0, 20)}
                        </span>
                      )}
                          </div>
                        </td>

                        {/* Created At */}
                        <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                          {file.updatedAt?.slice(0, 10)}
                        </td>

                        {/* Main Access */}
                        <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            {value[index]?.profile && (
                              <img
                                src={value[index].profile}
                                alt="profile"
                                className="w-5 h-5 rounded-full"
                              />
                            )}
                            {value[index]?.avatar && (
                              <img
                                src={value[index].avatar}
                                alt="avatar"
                                className="w-5 h-5 rounded-full"
                              />
                            )}
                          </div>
                        </td>

                        {/* Size */}
                        <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            {value[index]?.avatar1 && (
                              <img
                                src={value[index].avatar1}
                                alt="avatar"
                                className="w-5 h-5 rounded-full"
                              />
                            )}
                            <span>{value[index]?.size || "--"}</span>
                          </div>
                        </td>

                        {/* More */}
                        <td className="p-2 md:p-4 relative text-[12px] md:text-sm">
                          <div
                            className="inline-flex items-center justify-center text-secondary cursor-pointer"
                            onClick={() =>
                              setMenuOpenId(
                                menuOpenId === fileId ? null : fileId
                              )
                            }
                          >
                            <HiDotsVertical fontSize={20} />
                          </div>

                          {menuOpenId === fileId && (
                            <MenuComponent
                              datas={files}
                              file={file}
                              setMenuOpenId={setMenuOpenId}
                              renameValue={renameValue}
                              setRenameValue={setRenameValue}
                              setRenamingId={setRenamingId}
                              showShareModal={showShareModal}
                              infoModel={infoModel}
                              setInfoModel={setInfoModel}
                              setShowShareModal={setShowShareModal}
                              showInfoModal={showInfoModal}
                              setShowInfoModal={setShowInfoModal}
                              setInfoFile={setInfoFile}
                            />
                          )}

                          {showShareModal && (
                            <ShareView
                              setIsOpen={setShowShareModal}
                              handleShare={() => {
                                toast.success("File shared successfully!");
                                setShowShareModal(false);
                              }}
                            />
                          )}

                          <FileInformation
                            showInfoModal={showInfoModal}
                            infoFile={infoFile}
                            onClose={() => setShowInfoModal(false)}
                          />

                          {showMoveModal && selectedForMove && (
                            <MoveModal
                              file={selectedForMove}
                              folders={files.filter(
                                (f) => f.isDirectory && !f.trashed
                              )}
                              onClose={() => setShowMoveModal(false)}
                              onMove={(destinationId) => {
                                setFiles((prev) =>
                                  prev.map((f) =>
                                    f._id === selectedForMove._id
                                      ? { ...f, parentId: destinationId }
                                      : f
                                  )
                                );
                                setShowMoveModal(false);
                                toast.success("Moved successfully");
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}

                {/* Delete Popup */}
                {isPopupOpen && (
                  <tr>
                    <td colSpan={5}>
                      <DeleteView
                        handleDeleteCancel={handleDeleteCancel}
                        handleDeleteConfirm={handleDeleteConfirm}
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

           <div className="flex justify-between mt-5">
            <h4 className="text-secondary font-semibold text-xl">
              Suggested Files
            </h4>
            <button
              className="w-[150px] h-10 flex items-center justify-center gap-2 border border-gray-300 bg-four text-secondary font-medium text-sm rounded-md hover:opacity-90 transition"
              onClick={() => setShowAllFile(!showAllFile)}
            >
              <span>View all</span>
              <IoIosArrowUp
                fontSize={20}
                className={`transition-transform duration-300 ${
                  showAllFile ? "rotate-180" : ""
                }`}
              />
            </button>
          </div>

          <div className="w-full overflow-x-auto mt-5">
            <table
              ref={menuRef}
              className="min-w-[700px] w-full table-auto  text-sm text-left"
            >
              <thead className=" text-xs md:text-sm">
                <tr className="text-secondary font-semibold">
                  {["Name", "Created At", "Main Access", "Size", "More"].map(
                    (col, i) => (
                      <th
                        key={i}
                        className="p-2 md:p-4 whitespace-nowrap text-secondary"
                      >
                        {col}
                      </th>
                    )
                  )}
                </tr>
              </thead>

              <tbody>
                {filteredDatas
                  .filter((file) => !file.trashed)
                  .filter((item) => item.type === "file")
                  .slice(0, showAllFile ? datas.length : 5)
                  .map((file, index) => {
                    const fileId = file.id || file._id;
                    const handleRenameConfirm = () => {
                      if (renameValue.trim()) {
                        setFiles((prev) =>
                          prev.map((f) =>
                            f._id === file._id
                              ? { ...f, name: renameValue.trim() }
                              : f
                          )
                        );
                      }
                      setRenamingId(null);
                    };

                    return (
                      <tr
                        key={fileId}
                        className="hover:bg-third transition-all duration-200"
                      >
                        {/* Name */}
                        <td className="p-2 md:p-4 text-secondary">
                          <div className="flex items-center gap-5 ">
                            <div className="relative w-8 h-8 md:w-10 md:h-10">
                              {file.isLocked && (
                                <FaLock
                                  className="absolute top-0 left-0 text-red-500 z-10"
                                  fontSize={14}
                                />
                              )}
                              <img
                                src={getFileIcon(file.name, file.url)}
                                alt={file.name}
                                onClick={() => handleItemClick(file)}
                                className={`w-full h-full rounded-md object-cover transition-all duration-300 ${
                                  file.isLocked && !file.isDirectory
                                    ? "blur-md opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                              />
                            </div>
                            {renamingId === file._id ? (
                              <input
                                autoFocus
                                value={renameValue}
                                onChange={(e) => setRenameValue(e.target.value)}
                                onBlur={() => setRenamingId(null)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") handleRenameConfirm();
                                  else if (e.key === "Escape")
                                    setRenamingId(null);
                                }}
                                className="text-sm border outline-none  px-2 py-1 w-full rounded-md"
                              />
                            ) : (
                              <span
                                className=" font-medium text-sm truncate cursor-pointer"
                                onClick={() =>
                                  !file.isLocked &&
                                  (file.isDirectory
                                    ? handleFolderClick(file)
                                    : handleItemClick(file))
                                }
                              >
                                {file.name.slice(0, 10)}
                              </span>
                            )}
                          </div>
                        </td>

                        {/* Created At */}
                        <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                          {file.updatedAt?.slice(0, 10)}
                        </td>

                        {/* Main Access */}
                        <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            {value[index]?.profile && (
                              <img
                                src={value[index].profile}
                                alt="profile"
                                className="w-5 h-5 rounded-full"
                              />
                            )}
                            {value[index]?.avatar && (
                              <img
                                src={value[index].avatar}
                                alt="avatar"
                                className="w-5 h-5 rounded-full"
                              />
                            )}
                          </div>
                        </td>

                        {/* Size */}
                        <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            {value[index]?.avatar1 && (
                              <img
                                src={value[index].avatar1}
                                alt="avatar"
                                className="w-5 h-5 rounded-full"
                              />
                            )}
                            <span>{value[index]?.size || "--"}</span>
                          </div>
                        </td>

                        {/* More */}
                        <td className="p-2 md:p-4 relative text-[12px] md:text-sm">
                          <div
                            className="inline-flex items-center justify-center text-secondary cursor-pointer"
                            onClick={() =>
                              setMenuOpenId(
                                menuOpenId === fileId ? null : fileId
                              )
                            }
                          >
                            <HiDotsVertical fontSize={20} />
                          </div>

                          {menuOpenId === fileId && (
                            <MenuComponent
                              datas={files}
                              file={file}
                              setMenuOpenId={setMenuOpenId}
                              renameValue={renameValue}
                              setRenameValue={setRenameValue}
                              setRenamingId={setRenamingId}
                              showShareModal={showShareModal}
                              infoModel={infoModel}
                              setInfoModel={setInfoModel}
                              setShowShareModal={setShowShareModal}
                              showInfoModal={showInfoModal}
                              setShowInfoModal={setShowInfoModal}
                              setInfoFile={setInfoFile}
                            />
                          )}

                          {showShareModal && (
                            <ShareView
                              setIsOpen={setShowShareModal}
                              handleShare={() => {
                                toast.success("File shared successfully!");
                                setShowShareModal(false);
                              }}
                            />
                          )}

                          <FileInformation
                            showInfoModal={showInfoModal}
                            infoFile={infoFile}
                            onClose={() => setShowInfoModal(false)}
                          />

                          {showMoveModal && selectedForMove && (
                            <MoveModal
                              file={selectedForMove}
                              folders={files.filter(
                                (f) => f.isDirectory && !f.trashed
                              )}
                              onClose={() => setShowMoveModal(false)}
                              onMove={(destinationId) => {
                                setFiles((prev) =>
                                  prev.map((f) =>
                                    f._id === selectedForMove._id
                                      ? { ...f, parentId: destinationId }
                                      : f
                                  )
                                );
                                setShowMoveModal(false);
                                toast.success("Moved successfully");
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}

                {/* Delete Popup */}
                {isPopupOpen && (
                  <tr>
                    <td colSpan={5}>
                      <DeleteView
                        handleDeleteCancel={handleDeleteCancel}
                        handleDeleteConfirm={handleDeleteConfirm}
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
      
        </div>
      )}
      <div>
         {isCreateModalOpen && (
                  <CreateView
                    files={files}
                    setFiles={setFiles}
                    currentFolder={currentFolder}
                    setIsCreateModalOpen={handleCreate}
                    fileType={fileType}
                    setFileType={setFileType}
                    fileInput={fileInput}
                    setFileInput={setFileInput}
                  />
                )}
        
                {selectedFile && (
                  <FileView
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                    handleDownload={handleDownload}
                  />
                )}
        
      </div>
    </div>
  );
};

export default Home;
